//import '../../../resources/styles/components/commons/locationmarker.scss';
import L, { divIcon } from 'leaflet';
import ReactDOMServer from 'react-dom/server';
import { Marker, Popup } from 'react-leaflet';
import '../../../resources/styles/components/commons/locationmarker.scss';

export default function MarkerL(props) {
  const size = { x: props.x ?? 25, y: props.y ?? 25 };

  const createIcon = (url) => {
    return L.icon({
      iconUrl: url,
      zIndex: props.zIndex,
      options: {
        objectFit: 'cover',
      },
      iconSize: size as any,
      iconAnchor: props.iconAnchor ?? [10, 30],
    } as any);
  };

  return !props.isDisabled && props.position?.lat && props.position?.lng ? (
    <Marker
      position={props.position}
      draggable={props.draggable}
      icon={
        props.url
          ? (createIcon(props.url) as any)
          : props.divUrl
          ? divIcon({
              className: props.divClassname ? 'selected' : '',
              iconSize: size as any,
              iconAnchor: props.iconAnchor ?? [10, 30],
              html: ReactDOMServer.renderToString(props.divUrl),
            })
          : null
      }
      //Revisar añadir onClick y onDrag
      eventHandlers={{ click: props?.onClick, dragend: props?.onDragEnd }}
    >
      {props.title ? (
        <Popup offset={[0, -20]} closeButton={false}>
          {props.title}
        </Popup>
      ) : null}
    </Marker>
  ) : null;
}
